import { policyTipsLearnMoreLink } from './createPolicyTipsPeekInfoBarAction.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import PolicyTipsPeek from '../components/PolicyTipsPeek';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';

import { InfoBarCalloutAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

const POLICY_TIPS_PEEK_MAX_WIDTH = 320;

export function createPolicyTipsPeekInfoBarAction(
    policyTipsViewState: PolicyTipsViewState
): InfoBarCalloutAction {
    return {
        text: loc(policyTipsLearnMoreLink),
        calloutContent: <PolicyTipsPeek viewState={policyTipsViewState} />,
        maxWidth: POLICY_TIPS_PEEK_MAX_WIDTH,
    };
}
